import React from 'react';
import { Check } from 'lucide-react';
export function TargetAudienceSection() {
  const points = ['Siempre das más de lo que recibes.', 'Te cuesta decir NO.', 'Has permanecido en relaciones que te lastiman.', 'Sientes que te has olvidado de ti misma.', 'Buscas constantemente aprobación.', 'Quieres volver a sentirte suficiente.', 'Sabes que mereces más, pero no sabes cómo empezar.'];
  return <section className="w-full bg-brand-wine py-16 md:py-24 px-4 text-white" data-id="element-153">
      <div className="max-w-3xl mx-auto" data-id="element-154">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-center text-brand-gold mb-12 leading-tight" data-id="element-155">
          ESTE LIBRO ES PARA TI SI...
        </h2>

        <div className="bg-brand-wineDark rounded-2xl p-8 md:p-12 shadow-2xl border border-white/10" data-id="element-156">
          <div className="space-y-6" data-id="element-157">
            {points.map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-158">
                <div className="mt-1 bg-brand-gold/20 p-1 rounded-full flex-shrink-0" data-id="element-159">
                  <Check className="w-5 h-5 text-brand-gold" strokeWidth={3} data-id="element-160" />
                </div>
                <span className="text-xl text-white font-medium" data-id="element-161">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}